import ModusServiceModel from "../ModusServiceModel";
import CustomerModel from "@/models/crm/CustomerModel";

export default class LaboratoryClientContact extends ModusServiceModel {
  modelName() {
    return "laboratory-client-contacts";
  }
  defaults() {
    return {
      id: null,
      laboratory_client_id: null,
      laboratory_client: null,
      name: null,
      address: null,
      phone: null,
      email: null,
      accept_notifications: null,
      status: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      laboratory_client_id: val => this.nullStringMutator(val),
      laboratory_client: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      address: val => this.nullStringMutator(val),
      phone: val => this.nullStringMutator(val),
      email: val => this.nullStringMutator(val),
      accept_notifications: val => this.nullStringMutator(val),
      status: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  getLaboratoryClient() {
    return this.getRelatedModel(CustomerModel, "laboratory_client");
  }
}
